import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {Offer3dView} from "../constants/offer_3d_views";

export type IConstructionGalleryResponse = (
    | {
          image: string;
          tags?: {
              tag_date: string;
              tag_status: ConstructionGalleryTagValue;
          };
      }
    | undefined
)[];

export type IConstructionGalleryApiResponse = {
    gallery: IConstructionGalleryResponse;
    construction_3d_tours?: Offer3dView[] | null;
};

export type ConstructionGalleryTagValue = 1 | 2 | 3 | 4 | 5 | 6;

const constructionGalleryTagLabels: Record<ConstructionGalleryTagValue, string> = {
    1: "Rozpoczęcie budowy",
    2: "Prace ziemne",
    3: "Stan surowy otwarty",
    4: "Stan surowy zamknięty",
    5: "Prace wykończeniowe",
    6: "Oddane do użytkowania"
};

export const getConstructionGalleryTagLabel = (tag: ConstructionGalleryTagValue) => {
    const label = constructionGalleryTagLabels[tag];
    if (!label) {
        notifyBugsnag(
            {message: `Unknown construction gallery tag: ${tag}`, groupingHash: "getConstructionGalleryTagLabel"},
            `Unknown construction gallery tag: ${tag}`
        );
        return null;
    }
    return constructionGalleryTagLabels[tag];
};
import {notifyBugsnag} from "../../errors/bugsnag/notify_bugsnag";
import {Offer3dView} from "../constants/offer_3d_views";

export type IConstructionGalleryResponse = (
    | {
          image: string;
          tags?: {
              tag_date: string;
              tag_status: ConstructionGalleryTagValue;
          };
      }
    | undefined
)[];

export type IConstructionGalleryApiResponse = {
    gallery: IConstructionGalleryResponse;
    construction_3d_tours?: Offer3dView[] | null;
};

export type ConstructionGalleryTagValue = 1 | 2 | 3 | 4 | 5 | 6;

const constructionGalleryTagLabels: Record<ConstructionGalleryTagValue, string> = {
    1: "Rozpoczęcie budowy",
    2: "Prace ziemne",
    3: "Stan surowy otwarty",
    4: "Stan surowy zamknięty",
    5: "Prace wykończeniowe",
    6: "Oddane do użytkowania"
};

export const getConstructionGalleryTagLabel = (tag: ConstructionGalleryTagValue) => {
    const label = constructionGalleryTagLabels[tag];
    if (!label) {
        notifyBugsnag(
            {message: `Unknown construction gallery tag: ${tag}`, groupingHash: "getConstructionGalleryTagLabel"},
            `Unknown construction gallery tag: ${tag}`
        );
        return null;
    }
    return constructionGalleryTagLabels[tag];
};
